import React, {useState} from 'react';
import "./DropdownSizes.css";

const DropdownTaglie = ({product, handleChangeSize, current}) => {
        const [showSizes, setShowSizes] = useState(false);

        const taglieAttribute = product.attributes.find(
            attr => attr.set_name === "Taglie" || attr.set_name === "Taglia"
        );

        if (!taglieAttribute) return null;

        return (
            <div className="d-flex align-items-center dropdown sizes">
                <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownTaglieButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    {current ? "Taglia: " + current : "Seleziona taglia"}
                </button>
                <div
                    className="info-icon"
                    onClick={() => setShowSizes(!showSizes)}
                    title="Clicca per maggiori informazioni"
                >
                    <i className="fas fa-info"></i>
                </div>

                {showSizes && (
                    <div className="product-tooltip scrollable-tooltip" dangerouslySetInnerHTML={{__html: product.size_guide}}>
                    </div>
                )}

                <div className="dropdown-menu sizes dropdown-menu-end" aria-labelledby="dropdownTaglieButton">
                    {taglieAttribute.attributes.map(t => (
                        <li className={"dropdown-item"}
                           key={t.id}

                           onClick={(e) => {
                                   handleChangeSize(t.name);
                           }}>
                                {t.name}
                        </li>
                    ))}
                </div>
            </div>
        );
    }
;

export default DropdownTaglie;